import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  const whatsappNumber = '+6289502452140';
  const whatsappMessage = encodeURIComponent('Halo ISK, saya tertarik untuk berdiskusi tentang pengelolaan properti kost.');

  const handleClick = () => {
    window.open(
      `https://wa.me/${whatsappNumber.replace(/[^0-9+]/g, '')}?text=${whatsappMessage}`,
      '_blank'
    );
  };

  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.3, delay: 1 }}
      onClick={handleClick}
      className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-2xl hover:shadow-green-500/50 flex items-center justify-center transition-all hover:scale-110"
      data-testid="whatsapp-button"
      aria-label="Contact via WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-9 h-9 fill-white" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.004 2C8.28 2 2 8.278 2 16c0 2.49.658 4.834 1.804 6.855L2 30l7.332-1.776A14.006 14.006 0 0 0 16.004 30C23.726 30 30 23.722 30 16S23.726 2 16.004 2zm0 25.6a11.59 11.59 0 0 1-5.918-1.618l-.424-.252-4.353 1.054 1.083-4.25-.277-.436A11.545 11.545 0 0 1 4.4 16c0-6.397 5.207-11.6 11.604-11.6C22.4 4.4 27.6 9.603 27.6 16c0 6.397-5.2 11.6-11.596 11.6zm6.368-8.686c-.35-.175-2.07-1.02-2.39-1.137-.32-.117-.553-.175-.787.175-.233.35-.903 1.137-1.107 1.37-.203.233-.407.262-.757.087-.35-.175-1.477-.544-2.813-1.736-1.04-.927-1.742-2.072-1.946-2.422-.203-.35-.022-.54.153-.714.157-.157.35-.408.524-.612.175-.204.233-.35.35-.583.117-.234.058-.438-.029-.612-.087-.175-.787-1.894-1.078-2.594-.284-.682-.572-.59-.787-.6-.203-.01-.437-.012-.67-.012-.234 0-.612.087-.932.437-.32.35-1.224 1.196-1.224 2.916 0 1.72 1.253 3.382 1.428 3.615.175.234 2.467 3.767 5.98 5.28.836.36 1.488.575 1.997.737.839.267 1.602.229 2.207.139.673-.1 2.07-.846 2.362-1.663.292-.816.292-1.516.204-1.663-.087-.146-.32-.233-.67-.408z"/>
      </svg>
    </motion.button>
  );
};

export default WhatsAppButton;
